module.exports = __webpack_public_path__ + "img/inquiry.13a93f4f.svg";